module.exports = __webpack_public_path__ + "fonts/Roboto-Boldc0f1e4a4fdfb8048c72e86aadb2a247d.woff2]";